import { useEffect, useState } from "react";
import { useAppContext } from "@/src/config/AppProvider";
import Link from "next/link";
import Image from "next/image";
import RightSide from "./RightSide";
import SearchDropdown from "./SearchDropdown";
import Branches from "./Branches";
import Navigations from "./Navigations";

const MainHeader = () => {
  const [isSticky, setIsSticky] = useState(false);
  const { licenceSettings } = useAppContext();

  useEffect(() => {
    const handleScroll = () => {
      const scrolled = window.scrollY;
      if (scrolled > 0) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <div className={`rbt-header-wrapper header-sticky header-space-betwween ${isSticky ? "rbt-sticky" : ""}`}>
        <div className="container">
          <div className={`mainbar-row rbt-navigation-start align-items-center`}>
            <div className="header-left rbt-header-content">
              <div className="header-info">
                <div
                  className="logo"
                  style={{
                    width: "152px",
                    height: "50px"
                  }}
                >
                  <Link href="/">
                    <Image src={licenceSettings.LogoUrl} width={152} height={50} priority={true} alt={licenceSettings.SiteTitle} />
                  </Link>
                </div>
              </div>
              <div className="header-info d-lg-block ml--10">
                <Branches />
              </div>
            </div>
            <div className="rbt-main-navigation d-none d-xl-block">
              <Navigations />
            </div>
            <RightSide />
          </div>
        </div>
        <SearchDropdown />
      </div>
    </>
  );
};

export default MainHeader;
